import { IconButton, Menu, MenuItem, Tooltip, Zoom } from "@mui/material"
import { Fragment, memo, useState } from "react"

const GameAction = memo(function GameAction({ gameId, actionList }) {
  const [anchorEle, setAnchorEle] = useState(null)
  const isActionMenuOpen = Boolean(anchorEle)

  const handleActionMenuClick = (event) => {
    setAnchorEle(event.currentTarget)
  }

  const handleActionMenuClose = () => {
    setAnchorEle(null)
  }

  return (
    <Fragment>
      <Tooltip title="Exercise Actions" arrow TransitionComponent={Zoom}>
        <IconButton
          onClick={handleActionMenuClick}
          aria-controls={isActionMenuOpen ? "game-action" : undefined}
          aria-haspopup="true"
          aria-expanded={isActionMenuOpen ? "true" : undefined}
          className="clickable"
        >
          <i className={`fa-solid fa-ellipsis-vertical`}></i>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEle}
        id={gameId}
        open={isActionMenuOpen}
        onClose={handleActionMenuClose}
        onClick={handleActionMenuClose}
        PaperProps={{
          sx: {
            backgroundColor: "var(--ct-surface)",
            border: "1px solid var(--ct-line-3)",
            borderRadius: "12px",
            boxShadow: "0 16px 48px rgba(0,0,0,.18)",
            padding: "4px",
            minWidth: 260,
            mt: 0.5,
          },
        }}
        MenuListProps={{ sx: { padding: 0 } }}
        transformOrigin={{
          horizontal: "right",
          vertical: "top",
        }}
        anchorOrigin={{
          horizontal: "right",
          vertical: "bottom",
        }}
      >
        {actionList.map((actionItem) => {
          // Quiet ink menu; accent is reserved for the one state-changing item
          // (mark / unmark finished). Everything else is ink text with gray icons.
          const isStateChange = actionItem.iconName === "flag-checkered" || actionItem.iconName === "ban"
          const isInvite = typeof actionItem.actionText === "string" && actionItem.actionText.startsWith("Send Invitation")
          const inviteEmail = isInvite ? actionItem.actionText.split(":").slice(1).join(":").trim() : null
          return (
            <MenuItem
              key={actionItem.key}
              onClick={actionItem.clickHandler}
              className="game-action-menu-item"
              data-game-status={actionItem.gameStatus}
              sx={{
                fontSize: "13px",
                fontWeight: 500,
                color: isStateChange ? "var(--ct-gold-deep)" : "var(--ct-ink-strong)",
                padding: "9px 12px",
                borderRadius: "8px",
                minHeight: 0,
                gap: "10px",
                "&:hover": {
                  backgroundColor: "var(--ct-hover)",
                  color: isStateChange ? "var(--ct-gold-deep)" : "var(--ct-ink-strong)",
                },
                "& .kebab-ic": {
                  fontSize: "16px",
                  width: 16,
                  textAlign: "center",
                  flex: "0 0 16px",
                  color: isStateChange ? "var(--ct-gold-deep)" : "var(--ct-ink-4)",
                },
              }}
            >
              <span className="kebab-ic">
                <i className={`fa-solid fa-${actionItem.iconName}`}></i>
              </span>
              {isInvite ? (
                <span>
                  Send invitation <span style={{ color: "var(--ct-ink-3)", fontWeight: 400 }}>· {inviteEmail}</span>
                </span>
              ) : (
                <span>{actionItem.actionText}</span>
              )}
            </MenuItem>
          )
        })}
      </Menu>
    </Fragment>
  )
})

GameAction.displayName = "GameAction"

export default GameAction
